import { useMemo } from 'react';
import styles from '../styles.module.scss';

const lineHeights = ['1', '1.2', '1.4', '1.6', '1.8', '2'];

export default function LineHeightPicker({ onClick }) {
  const handleOnClick = (event) => {
    if (!onClick) return;

    const lineHeight = event.target.dataset.value;
    if (lineHeight) {
      onClick(lineHeight);
    }
  };

  const renderLineHeightButton = (lineHeight, onClickHandler) => (
    <button
      key={lineHeight}
      className={styles['dropdown-item']}
      type="button"
      onClick={onClickHandler}
      data-event="backLineHeight"
      data-value={lineHeight}
    >
      {lineHeight}
    </button>
  );

  const renderDropdownItems = useMemo(() => {
    const dropdown = [];
    for (let i = 0; i < lineHeights.length; i++) {
      const lineHeight = lineHeights[i];
      dropdown.push(renderLineHeightButton(lineHeight, handleOnClick));
    }

    return dropdown;
  }, [lineHeights]);

  return <div className={styles.dropdown}>{renderDropdownItems}</div>;
}
